import React from "react";
import MoodIcon from "@material-ui/icons/Mood";
import FlareIcon from "@material-ui/icons/Flare";
import PlaceIcon from "@material-ui/icons/Place";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ListIcon from "@material-ui/icons/List";
import KitchenIcon from "@material-ui/icons/Kitchen";
import WifiIcon from "@material-ui/icons/Wifi";
import MotorcycleIcon from "@material-ui/icons/Motorcycle";
import PhoneEnabledIcon from "@material-ui/icons/PhoneEnabled";
import DiscFullIcon from "@material-ui/icons/DiscFull";
const roomInfo = [
  [
    {
      icon: <MoodIcon />,
      title: "Nguyen là Chủ nhà siêu cấp",
      content:
        "Chủ nhà siêu cấp là những chủ nhà có kinh nghiệm, được đánh giá cao và là những người cam kết mang lại quãng thời gian ở tuyệt vời cho khách.",
    },
    {
      icon: <FlareIcon />,
      title: "Vệ sinh tăng cường",
      content:
        "Chủ nhà này đã cam kết thực hiện quy trình vệ sinh tăng cường 5 bước của Airbnb. Tìm hiểu thêm",
    },
    {
      icon: <PlaceIcon />,
      title: "Địa điểm tuyệt vời",
      content: "100% khách gần đây đã xếp hạng 5 sao cho vị trí này",
    },
    {
      icon: <CalendarTodayIcon />,
      title: "Chính sách hủy",
      content:
        "Thêm ngày cho chuyến đi của bạn để nhận thông tin về chính sách hủy cho đặt phòng này.",
    },
    {
      icon: <ListIcon />,
      title: "Nội quy nhà",
      content:
        "Chủ nhà không cho phép mang theo thú cưng, tổ chức tiệc tùng hoặc hút thuốc. Tìm hiểu chi tiết",
    },
  ],
  [
    {
      icon: <DiscFullIcon />,
      title: "Máy báo cháy",
    },
    {
      icon: <KitchenIcon />,
      title: "Bếp",
    },
    {
      icon: <MoodIcon />,
      title: "Máy sấy tóc",
    },
    {
      icon: <WifiIcon />,
      title: "Wifi",
    },

    {
      icon: <MotorcycleIcon />,
      title: "Chỗ đỗ xe miễn phí tại nơi ở",
    },
    {
      icon: <MoodIcon />,
      title: "Bình chữa cháy",
    },
    {
      icon: <PhoneEnabledIcon />,
      title: "Tiện nghi thiết yếu",
    },
    {},
  ],
  [
    {
      crit: "Mức độ sạch sẽ",
      rate: "5.0",
    },
    {
      crit: "Tính xác thực",
      rate: "5.0",
    },
    {
      crit: "Liên lạc",
      rate: "5.0",
    },
    {
      crit: "Vị trí",
      rate: "5.0",
    },
  ],
  [
    {
      name: "Hoang Oanh",
      date: "tháng 3 năm 2020",
      comment: "Hight recommended. The room in the hotel was good.",
    },
    {
      name: "Uwe",
      date: "tháng 5 năm 2020",
      comment: "The room in the hotel was good. He was clean and climate.",
    },
    {
      name: "Mark",
      date: "tháng 7 năm 2020",
      comment: "Great apartment, kind hostess. I recommend to everyone !",
    },
  ],
];

export default roomInfo;
